import type {
  CommunityFeedAudienceGroupV2Dto,
  CommunityFeedAudienceProjectConnectionV2Dto,
  CommunityFeedAudienceProjectV2Dto,
  CommunityFeedSelectableAudienceV2Dto,
  MentionInputDto,
  MessageV2Dto,
} from "@/api/types";
import type { FormDocument } from "@/components/DocumentInput/useDocumentInput";
import type { FormImage } from "@/components/ImageInput/useImageInput";
import type { FormVideo } from "@/components/VideoInput/useVideoInput";

export enum CommunityPostStatus {
  JUST_DELIVERED,
  DELIVERED,
  JUST_SCHEDULED,
  SCHEDULED,
  ARCHIVED,
  DELETED,
}

/** Shared message-owned activity contract, also used by poll attachments. */
export type CommunityMessageActivity = Pick<
  MessageV2Dto,
  | "id"
  | "type"
  | "canComment"
  | "canLike"
  | "canShare"
  | "lastActivityAt"
  | "requesterReactionType"
  | "totalCommentCount"
  | "totalReactionCountByType"
  | "postedAt"
  | "scheduledAt"
  | "deletedAt"
  | "archivedAt"
  | "isInactivePost"
> &
  Partial<Pick<MessageV2Dto, "group" | "messageLabel">>;

export interface ResidentCreatePostModalFormValues {
  group?: CommunityFeedAudienceItem;
  audience?: CommunityFeedSelectableAudienceV2Dto;
  title: string;
  content: string;
  contentTemplate?: string;
  mentions?: MentionInputDto[];
  hideFromAdmin: boolean;
  images: FormImage[];
  documents: FormDocument[];
  videos: FormVideo[];
}

export type CommunityFeedAudienceItem =
  | { type: "group"; value: CommunityFeedAudienceGroupV2Dto }
  | { type: "project"; value: CommunityFeedAudienceProjectV2Dto }
  | { type: "projectConnection"; value: CommunityFeedAudienceProjectConnectionV2Dto };
